import axios from 'axios';
import API_CONFIG from './apiConfig';

const apiClient = axios.create({
   baseURL:API_CONFIG.BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },   
});

// Request interceptor to add Authorization token
apiClient.interceptors.request.use(
  (config) => {
    const publicEndpoints = [
      '/api/auth',
      '/api/register',
      '/api/forgot-password',
      '/api/verify-otp',
      '/api/reset-password',
    ];

    if (!publicEndpoints.includes(config.url)) {
      const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for handling errors globally (optional)
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // Handle global errors, e.g., 401 Unauthorized
    if (error.response?.status === 401) {
      // Optionally clear storage and redirect to login
      if (originalRequest._retry) {
        return Promise.reject(error);
      }
      originalRequest._retry = true;
      if (window.location.pathname !== '/auth/signin') {
        return Promise.reject(error);
      }
      localStorage.removeItem('authToken');
      sessionStorage.removeItem('authToken');
      localStorage.removeItem('userName');
      localStorage.removeItem('userId');
      localStorage.removeItem('email');
      sessionStorage.removeItem('userName');
      sessionStorage.removeItem('userId');
      sessionStorage.removeItem('email');
      window.location.href = '/auth/signin';
    }
    if (error.response?.status === 403) {

      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default apiClient;